<template>
    <div>
        <b-navbar fixed="top" toggleable="lg" type="dark" variant="dark">
            <b-navbar-nav v-if="isLoggedIn">
                <b-nav-item @click="showSideBar = !showSideBar">
                    <hamburger-icon></hamburger-icon>
                </b-nav-item>
            </b-navbar-nav>

            <b-navbar-brand href="#">
                <slot name="brand"></slot>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <slot name="left-hand-side"></slot>

                <b-navbar-nav>
                    <b-nav-item :to="{ name: 'home' }" v-show="isLoggedIn">
                        <home-icon></home-icon>
                    </b-nav-item>

                    <b-nav-item-dropdown
                        :key="index"
                        :text="menu_item.name"
                        v-for="(menu_item, index) in filtered_items"
                        v-show="menu_item.loggedIn === isLoggedIn"
                    >
                        <b-dropdown-item
                            :key="childIndex"
                            :to="child.to"
                            v-for="(child, childIndex) in menu_item.children"
                            v-show="child.loggedIn === isLoggedIn"
                            >{{ child.title }}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>

                    <slot name="middle-side"></slot>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown
                        right
                        v-if="currentUser"
                        v-show="isLoggedIn"
                    >
                        <!-- Using 'button-content' slot -->
                        <template slot="button-content"
                            ><span v-if="currentUser">{{
                                currentUser.descriptive_name
                            }}</span>
                        </template>
                        <b-dropdown-item :href="admin_link" v-if="currentUser"
                            >Profile</b-dropdown-item
                        >
                        <b-dropdown-item :href="admin_link" v-if="currentUser"
                            >Admin Dashboard</b-dropdown-item
                        >
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item
                            :to="{ name: 'logout' }"
                            v-show="isLoggedIn"
                            >Log Out</b-dropdown-item
                        >
                    </b-nav-item-dropdown>

                    <slot name="right-hand-side"></slot>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <o-side-bar :items="items" v-if="showSideBar"></o-side-bar>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import HomeIcon from "vue-material-design-icons/Home";
import OSideBar from "./OSideBar";
import HamburgerIcon from "vue-material-design-icons/Hamburger";
import MenuMixin from "./MenuMixin";

export default {
    components: { HamburgerIcon, OSideBar, HomeIcon },
    mixins: [MenuMixin],
    props: {
        items: {},
        admin_items: {},
        appName: {
            type: String,
            default: "Default App",
        },
    },
    data: () => ({
        showSideBar: false,
        admin_link: process.env.VUE_APP_ROOT_API + "/admin",
    }),
    computed: {
        ...mapGetters("AuthModule", ["isLoggedIn", "currentUser"]),
    },
    watch: {},
};
</script>
